"use es6";

export function isFunction(x) {
  return typeof x === 'function';
}